import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Quotation } from 'app/model/mice/mice.model'
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { DOCUMENT } from '@angular/common';
import { MiceServiceTypes } from 'app/model/constant';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'act-dialog-quotation-form',
  templateUrl: './dialog-quotation-form.component.html',
  styleUrls: ['./dialog-quotation-form.component.scss']
})
export class DialogQuotationFormComponent implements OnInit {
  public serviceTypesConstant = MiceServiceTypes.EN;
  public quotationForm: FormGroup;
  public quotationModel: Quotation;
  public serviceTypes: string[];
  public stateDaterangepicker: any;
  public isSubmitted = false;
  public maskPhoneNumber = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  public maskBudgetNumber = createNumberMask({
    prefix: '',
    integerLimit: 8,
    includeThousandsSeparator: true,
  });
  public maskAttendeesNumber = createNumberMask({
    prefix: '',
    integerLimit: 4,
    includeThousandsSeparator: true,
  });

  constructor(
    public dialogRef: MdDialogRef<DialogQuotationFormComponent>,
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document: any) { }

  ngOnInit() {
    this.setDefaultForm();
    this.setDropDownServiceTypeDisplay(this.appConfigService.getLanguage());
    this.utilitiesService.lockBodyMice();
  }
  
  ngOnDestroy() { 
    this.utilitiesService.unlockBodyMice();
  }

  setDefaultForm() {
    this.quotationForm = this.fb.group({
      serviceType: ['', Validators.required],
      destination: [''],
      budget: ['', [this.validateZeroInput]],
      attendees: ['', [this.validateZeroInput]],
      startDate: [null],
      endDate: [null],
      remark: [''],
      contactName: ['', [Validators.required, this.noWhitespaceValidator]],
      companyName: ['', [Validators.required, this.noWhitespaceValidator]],
      phone: ['', [Validators.required, this.noWhitespaceValidator, Validators.minLength(9)]],
      email: ['', [Validators.required, Validators.pattern(/[a-z0-9]+[_a-z0-9\.-]*[a-z0-9]+@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})/i)]],
    });
  }

  setDropDownServiceTypeDisplay(lang) {
    if (lang === 'th') {
      this.serviceTypes = MiceServiceTypes.TH;
    } else {
      this.serviceTypes = MiceServiceTypes.EN
    }
  }

  noWhitespaceValidator(formControl: FormControl) {
    const isWhitespace = (formControl.value || '').trim().length === 0;
    return !isWhitespace ? null : { 'whitespace': true };
  }

  validateZeroInput(formControl: FormControl) {
    const isZero = formControl.value === '0';
    return !isZero ? null : { 'zero': true };
  }

  closeDialog() {
    this.dialogRef.close({ status: false });
  }

  onSubmit() {
    if (this.quotationForm.valid) {
      this.quotationModel = this.quotationForm.value;
      this.quotationModel.destination = this.quotationModel.destination.trim();
      this.quotationModel.remark = this.quotationModel.remark.trim();
      this.quotationModel.contactName = this.quotationModel.contactName.trim();
      this.quotationModel.companyName = this.quotationModel.companyName.trim();
      this.quotationModel.email = this.quotationModel.email.trim();
      this.quotationModel.lang = this.appConfigService.getLanguage();
      this.quotationModel.serviceType = this.serviceTypesConstant[this.quotationForm.get('serviceType').value];
      this.quotationModel.attendees = null;
      this.quotationModel.budget = null;
      if (this.quotationForm.get('attendees').value.trim() !== '') {
        this.quotationModel.attendees = this.transformStringWithSeperatorToNumber(this.quotationForm.get('attendees').value, ',');
      }
      if (this.quotationForm.get('budget').value.trim() !== '') {
        this.quotationModel.budget = this.transformStringWithSeperatorToNumber(this.quotationForm.get('budget').value, ',');
      }
      this.dialogRef.close({ status: true, data: this.quotationModel });
    }
    this.isSubmitted = true;
  }

  transformStringWithSeperatorToNumber(value: string, seperator: string) {
    let result = '';
    const input = value.split(seperator);
    input.forEach(data => {
      result += data;
    })
    return Number(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-quotation-form/dialog-quotation-form.component.ts